import { useContext, useEffect } from "react";
import { useTypedFetcher } from "remix-typedjson";
import { BookingFormContext } from "~/components/booking/ContextProvider";
import { formatPrice } from "~/utils/format";
import { type loader as totalPriceLoader } from "~/routes/resources+/book+/total-price";
import { route } from "~/utils/route";

export function TotalPrice() {
  const context = useContext(BookingFormContext);
  if (!context) {
    throw new Error("BookingFormContext is not provided");
  }

  const { selectedBarberId, selectedServiceIds } = context;

  const totalPriceFetcher = useTypedFetcher<typeof totalPriceLoader>();
  const totalPrice = totalPriceFetcher.data?.totalPrice;

  useEffect(() => {
    const url = route("/resources/book/total-price");
    const searchParams = new URLSearchParams();
    searchParams.set("barberId", selectedBarberId);
    selectedServiceIds.forEach((serviceId) => {
      searchParams.append("serviceIds", serviceId);
    });

    totalPriceFetcher.load(url + "?" + searchParams.toString());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedBarberId, selectedServiceIds]);

  return (
    <div className="px-6">
      <div className="text-xl text-gray-400 font-semibold">Total</div>

      {totalPrice && totalPrice.greaterThan(0) ? (
        <>
          {totalPriceFetcher.data.servicesWithDetails.map((service) => (
            <div key={service.id} className="flex justify-between">
              <p>
                {service.name}{" "}
                {service.quantity > 1 ? `x${service.quantity}` : ""}
              </p>
              <p>{formatPrice(service.price.toString())}</p>
            </div>
          ))}

          <p className="mt-8">Final Price</p>
          <p className="text-3xl font-bold">
            {formatPrice(totalPrice.toString())}
          </p>
        </>
      ) : null}
    </div>
  );
}
